import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";
import { jwtDecode } from "jwt-decode";
import logoDark from "../images/logo.png";
import logoIcon from "../images/logo.ico";
import axiosInstance from "./AxiosInstance";

export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    "https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII",
    postData
  );
}

export function login(email, password) {
  const postData = {
    email,
    password,
    // role: "ADMIN",
    // returnSecureToken: true,
  };
  return axios.post(
    `${process.env.REACT_APP_DEV_API}/v1/iam/sign-in`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export async function fetchLogos() {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const orgId = userDetails?.user?.organizationId;
  try {
    const response = await axiosInstance.get(`/v1/organization/${orgId}`);
    const data = response.data;
    const organization = data.data.organization;
    const logoData = organization.logo;
    const currency = organization.currency;

    localStorage.setItem("currency", currency);
    localStorage.setItem(
      "horizontalLogo",
      logoData.horizontalLogoSignedUrl || logoDark
    );
    localStorage.setItem(
      "squareLogo",
      logoData.squareLogoSignedUrl || logoIcon
    );
    localStorage.setItem(
      "organizationUniqueName",
      organization.uniqueName
    );
    const jobTitleLabel = organization.jobTitleLabel || "Job";
    const chargeOutRateTitle = organization.chargeOutRateTitle || "Charge Out Rate";
    const costOfSupplyTitle = organization.costOfSupplyTitle || "Cost of Supply";
    localStorage.setItem("jobTitleLabel", jobTitleLabel);
    localStorage.setItem("chargeOutRateTitle", chargeOutRateTitle);
    localStorage.setItem("costOfSupplyTitle", costOfSupplyTitle);

    window.dispatchEvent(new Event("logoUpdated"));
    window.dispatchEvent(new Event("jobTitleLabelUpdated"));
    window.dispatchEvent(new Event("orgCustomLabelsUpdated"));
  } catch (error) {
    console.error("Error fetching organization details:", error);
    localStorage.setItem("horizontalLogo", logoDark);
    localStorage.setItem("squareLogo", logoIcon);
    localStorage.setItem("currency", "INR");
    localStorage.setItem("jobTitleLabel", "Job");
    localStorage.setItem("chargeOutRateTitle", "Charge Out Rate");
    localStorage.setItem("costOfSupplyTitle", "Cost of Supply");
  }
}

/**
 * Update organisation's default job title label (e.g. "Job" → "Booking").
 * On success, refreshes org data and dispatches jobTitleLabelUpdated so the UI updates.
 * @param {string} organizationId
 * @param {string} jobTitleLabel
 */
export async function updateOrganizationJobTitleLabel(organizationId, jobTitleLabel) {
  const response = await axiosInstance.put(`/v1/organization/${organizationId}`, {
    jobTitleLabel: (jobTitleLabel || "").trim() || "Job",
  });
  await fetchLogos();
  return response;
}

export async function updateOrganizationCustomLabels(
  organizationId,
  { jobTitleLabel, chargeOutRateTitle, costOfSupplyTitle }
) {
  const response = await axiosInstance.put(`/v1/organization/${organizationId}`, {
    jobTitleLabel: (jobTitleLabel || "").trim() || "Job",
    chargeOutRateTitle: (chargeOutRateTitle || "").trim() || "Charge Out Rate",
    costOfSupplyTitle: (costOfSupplyTitle || "").trim() || "Cost of Supply",
  });
  await fetchLogos();
  return response;
}

export function saveTokenInLocalStorage(tokenDetails) {
  //   tokenDetails.expireDate = new Date(
  //     new Date().getTime() + tokenDetails.expiresIn * 1000
  //   );
  const { role, organizationId } = tokenDetails.user;

  if (role === "SUPERADMIN") {
    localStorage.setItem("superAdminUser", JSON.stringify(tokenDetails));
  } else if (role === "ADMIN") {
    if (!organizationId) {
      throw new Error("Unable to login. Please contact customer support");
    }
    localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
  } else {
    throw new Error("Invalid user role");
  }
}

export function decodeTokenRole(token) {
  try {
    const decode = jwtDecode(token);
    return decode.user.role;
  } catch (error) {
    console.log("dcode", error);
    return null;
  }
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  console.log("autologin");
  const tokenDetailsObj =
    JSON.parse(localStorage.getItem("superAdminUser")) ||
    JSON.parse(localStorage.getItem("userDetails"));
  console.log(tokenDetailsObj);
  //   let tokenDetails = "";
  if (!tokenDetailsObj || (Object.keys(tokenDetailsObj).length = 0)) {
    dispatch(Logout(navigate));
    return;
  }

  //   tokenDetails = JSON.parse(tokenDetailsObj);
  //   let expireDate = new Date(tokenDetails.expireDate);
  //   let todaysDate = new Date();

  //   if (todaysDate > expireDate) {
  //     dispatch(Logout(navigate));
  //     return;
  //   }

  dispatch(loginConfirmedAction(tokenDetailsObj));
  // navigate("/dashboard");

  //   const timer = expireDate.getTime() - todaysDate.getTime();
  //   runLogoutTimer(dispatch, timer, navigate);
}

export function forgotPassword(email) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post("/v1/iam/otp", {
        email,
        role: "ADMIN"
      });

      if (response.data.status === "success") {
        resolve(response.data);
      } else {
        reject(new Error(response.data.message || "An error occurred"));
      }
    } catch (error) {
      console.error("Error while sending OTP:", error);
      reject(new Error("An error occurred, please try again."));
    }
  });
}

export function resetPassword(email, otp, password, recaptchaValue) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post("/v1/iam/reset-password", {
        email,
        otp,
        newPassword: password,
        gRecaptchaResponse: recaptchaValue
      });

      if (response.data.status === "success") {
        resolve(response.data);
      } else {
        reject(new Error(response.data.message || "An error occurred"));
      }
    } catch (error) {
      console.error("Error while resetting the password:", error.response.data.message);
      reject(new Error(`${error.response.data.message}`));

    }
  });
}

export function changePassword(oldPassword, newPassword) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.put("/v1/iam/change-password", {
        oldPassword,
        newPassword
      });

      if (response.data.message.includes("success")) {
        resolve(response.data);
      } else {
        reject(new Error(response.data.message || "An error occurred"));
      }
    } catch (error) {
      console.error("Error while changing the password:", error);
      reject(new Error(`${error.response.data.message}`));
    }
  });
}
